module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Electric/Iron-a5243fc362949524cc7cb3ba58759a34639bb4afa62ca1dedf49266104090c62.svg";